import Vue from 'vue'

import App from './customer-views/App.vue'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/vee-validate'
import { createProvider } from './vue-apollo'
import { currentSite, i18n } from './extend'
import * as CONST from '@/const/shared'

Vue.config.productionTip = false

const appElement = document.getElementById('app')
const appDataset = appElement.dataset
const layout = appDataset.layout

Vue.prototype.$layout = layout
Vue.prototype.$const = CONST

Object.defineProperty(Vue.prototype, '$site', {
  enumerable: true,
  get: currentSite
})

new Vue({
  render: h => h(App),
  store,
  vuetify,
  apolloProvider: createProvider(),
  i18n
}).$mount('#app')
